import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AspWebsiteSettingComponent } from './asp-website-setting.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import {MatListModule} from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { AspRequestDetailsModule } from '../asp-request-details/asp-request-details.module';
import { MatCheckboxModule } from '@angular/material/checkbox';

const routes: Routes = [
  {
    path: 'website-settings', 
    component: AspWebsiteSettingComponent
   
  },
];

@NgModule({
  declarations: [
    AspWebsiteSettingComponent
  ],
  imports: [
    CommonModule,
     RouterModule.forChild(routes),
        CommonModule, 
        HttpClientModule,
        BrowserModule,
        AspRequestDetailsModule ,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        MatTooltipModule,
        MatListModule,
        MatDialogModule,
        MatIconModule,
        MatSidenavModule,
        MatFormFieldModule,
        MatInputModule,
        MatBottomSheetModule,
        MatDividerModule,
        MatCardModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatOptionModule,
        MatCheckboxModule
  ],
    exports: [AspWebsiteSettingComponent, RouterModule],
})
export class AspWebsiteSettingModule { }
